 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"blank":"blank","checkou":"checkou","clientes~comissoes~dashboard":"clientes~comissoes~dashboard","clientes":"clientes","comissoes":"comissoes","dashboard":"dashboard","error":"error","login":"login","tickets":"tickets","usuario":"usuario","vendas":"vendas"}[chunkId]||chunkId) + "." + {"blank":"1e70bab8","checkou":"1d5e1d0f","chunk-2891b4e8":"345c00d2","clientes~comissoes~dashboard":"825d3385","clientes":"2cba11c3","comissoes":"e7acdf1c","dashboard":"eeb595a9","error":"2894466e","login":"4dbd5c55","tickets":"12c29e96","usuario":"5e30d9d5","vendas":"8a64dafb","chunk-2d217fdf":"35d923e4","chunk-a1c43faa":"d93a9a9c","chunk-3315aa2b":"d6aa1542","chunk-3ce2a70d":"08d4eaa2","chunk-5d5de4dc":"c3ded2a0","chunk-6e53dbe4":"ec622fe3","chunk-71cc61d6":"db33ee62","chunk-de76d454":"ae8a9c11","chunk-29bc4d48":"7d02299e","chunk-08c51ad4":"44ea4c97","chunk-2d0b9bc8":"14567795","chunk-15aff4f0":"678603aa","chunk-2d0d3e87":"7b870ef5","chunk-e5267ff6":"d7c11862","chunk-0761bbfe":"dde2a542","chunk-05291048":"aeffae26","chunk-2d0f083e":"502c6ff6","chunk-2d20ee0f":"42b41db4","chunk-43dc89b1":"eea86453","chunk-83bf0b1e":"5ef85cbc","chunk-2d2254c4":"595d1069","chunk-2d0c4847":"9f618ea0","chunk-3f864d64":"52857fb8","chunk-94bab9b2":"d568d96b","chunk-a998267e":"43cbcebf","chunk-925bf55e":"7a5b440b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"checkou":1,"clientes":1,"comissoes":1,"dashboard":1,"tickets":1,"chunk-a1c43faa":1,"chunk-3315aa2b":1,"chunk-3ce2a70d":1,"chunk-5d5de4dc":1,"chunk-6e53dbe4":1,"chunk-de76d454":1,"chunk-0761bbfe":1,"chunk-05291048":1,"chunk-43dc89b1":1,"chunk-83bf0b1e":1,"chunk-3f864d64":1,"chunk-a998267e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "assets/css/" + ({"blank":"blank","checkou":"checkou","clientes~comissoes~dashboard":"clientes~comissoes~dashboard","clientes":"clientes","comissoes":"comissoes","dashboard":"dashboard","error":"error","login":"login","tickets":"tickets","usuario":"usuario","vendas":"vendas"}[chunkId]||chunkId) + "." + {"blank":"31d6cfe0","checkou":"fc63bfa5","chunk-2891b4e8":"31d6cfe0","clientes~comissoes~dashboard":"31d6cfe0","clientes":"99be10a3","comissoes":"a98abcb2","dashboard":"d3863ce0","error":"31d6cfe0","login":"31d6cfe0","tickets":"81a2af48","usuario":"31d6cfe0","vendas":"31d6cfe0","chunk-2d217fdf":"31d6cfe0","chunk-a1c43faa":"d0db4022","chunk-3315aa2b":"01918d78","chunk-3ce2a70d":"a33a18a0","chunk-5d5de4dc":"983c2f74","chunk-6e53dbe4":"18a7f620","chunk-71cc61d6":"31d6cfe0","chunk-de76d454":"2fe6b70d","chunk-29bc4d48":"31d6cfe0","chunk-08c51ad4":"31d6cfe0","chunk-2d0b9bc8":"31d6cfe0","chunk-15aff4f0":"31d6cfe0","chunk-2d0d3e87":"31d6cfe0","chunk-e5267ff6":"31d6cfe0","chunk-0761bbfe":"2fe6b70d","chunk-05291048":"8fc95a28","chunk-2d0f083e":"31d6cfe0","chunk-2d20ee0f":"31d6cfe0","chunk-43dc89b1":"7d87dbc5","chunk-83bf0b1e":"fbf684ad","chunk-2d2254c4":"31d6cfe0","chunk-2d0c4847":"31d6cfe0","chunk-3f864d64":"13b10378","chunk-94bab9b2":"31d6cfe0","chunk-a998267e":"a486cf99","chunk-925bf55e":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/public/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
